module.exports = __webpack_public_path__ + "img/icon_empty.a9512ea6.png";